import { FC, ReactNode } from "react";
import { AmountButtons } from "../../Swap/components";
import BuyBox from "../../Swap/components/swap/tradeComponents/buyBox";
import cn from "classnames";
import styles from "@/pages/Swap/Swap.module.scss";
import { useSwap } from "@stores/swap.store";

interface CurrencyFormProps {
    title: string;
    amount: string | number;
    setAmount?: (value: string) => void;
    balance?: number | string;
    slot?: ReactNode;
    disableInput?: boolean;
    price?: number;
    isLoading?: boolean;
}

const CurrencyForm: FC<CurrencyFormProps> = ({
    title,

    amount,
    setAmount,
    balance,
    slot,
    disableInput = false,
    price,
    isLoading = false,
}) => {
    const isBalanceSufficient = useSwap((state) => state.isBalanceSufficient);

    return (
        <div className={"flex flex-col gap-2"}>
            <div className={styles.sellTop}>
                <div className="text-sm font-medium">{title}</div>
                <div className="flex items-center gap-2">
                    {balance !== undefined && (
                        <div className={cn(styles.balance, "text-sm")}>
                            Balance: <span className={!isBalanceSufficient() ? "text-primary" : ""}>{balance}</span>
                        </div>
                    )}
                    {slot}
                </div>
            </div>
            <div className={styles.middle}>
                <BuyBox
                    swapAmount={amount?.toString()}
                    setSwapAmount={setAmount || (() => {})}
                    symbol={""}
                    disabled={disableInput}
                />
                {balance !== undefined && setAmount && (
                    <AmountButtons
                        balance={balance?.toString()}
                        setAmount={setAmount} // Type is now guaranteed to be (value: string) => void
                        active={balance !== 0 && balance !== "connect wallet"}
                    />
                )}
            </div>
        </div>
    );
};

export default CurrencyForm;
